/* ============
 * packageUnitType Module Mutations
 * ============
 */

import {
  FETCH_ALL_PACKAGE_UNIT_TYPES,
  FETCH_CURRENT_PACKAGE_UNIT_TYPE,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PACKAGE_UNIT_TYPES](state, packageUnitTypes) {
    state.all = packageUnitTypes;
  },

  [FETCH_CURRENT_PACKAGE_UNIT_TYPE](state, packageUnitType) {
    state.currentpackageUnitType = packageUnitType;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/packageUnitType/mutations.js